import $ from 'jquery';
import $script from 'scriptjs';
import ShopifySectionsManager from 'shopify-sections-manager';
import PxsMap from 'pxs-map';
import 'intersection-observer';
import rimg from 'rimg-shopify';

import './utils/jquery';

// Templates
import TemplateAccountAddresses from './templates/TemplateAccountAddresses';
import TemplateAccountLogin from './templates/TemplateAccountLogin';
import TemplateCollection from './templates/TemplateCollection';
import TemplateGiftCard from './templates/TemplateGiftCard';
import TemplateIndex from './templates/TemplateIndex';
import TemplateListCollections from './templates/TemplateListCollections';
import TemplatePassword from './templates/TemplatePassword';

// Sections
import DynamicCollectionList from './sections/DynamicCollectionList';
import DynamicInstagram from './sections/DynamicInstagram';
import DynamicProduct from './sections/DynamicProduct';
import DynamicSlideshow from './sections/DynamicSlideshow';
import DynamicTwitter from './sections/DynamicTwitter';
import DynamicVideo from './sections/DynamicVideo';
import StaticArticle from './sections/StaticArticle';
import StaticCart from './sections/StaticCart';
import StaticHeader from './sections/StaticHeader';
import StaticProduct from './sections/StaticProduct';

// Components
import Quickshop from './components/Quickshop';
import Rte from './components/Rte';

const scriptsEl = document.querySelector('[data-scripts]');
const scripts = JSON.parse(scriptsEl.innerHTML);

export default class Atlantic {
  constructor() {
    this.el = document.body;
    this.$el = $(this.el);

    const sections = new ShopifySectionsManager();

    sections.register('dynamic-collection-list', section => new DynamicCollectionList(section));
    sections.register('dynamic-instagram', section => new DynamicInstagram(section));
    sections.register('dynamic-product', section => new DynamicProduct(section));
    sections.register('dynamic-slideshow', section => new DynamicSlideshow(section));
    sections.register('dynamic-twitter', section => new DynamicTwitter(section));
    sections.register('dynamic-video', section => new DynamicVideo(section));
    sections.register('static-article', () => new StaticArticle());
    sections.register('static-cart', section => new StaticCart(section));
    sections.register('static-product', section => new StaticProduct(section));
    sections.register('static-header', section => new StaticHeader(section));
    sections.register('pxs-map', section => new PxsMap(section));

    this.customerPage = this.$el.attr('class').indexOf('customer') > 0;

    if (navigator.userAgent.indexOf('MSIE 10.0') > 0) {
      $('html').addClass('ie10');
    }

    this.rte = [];
    const $rte = $('.rte');

    for (let i = 0; i < $rte.length; i++) {
      this.rte.push(new Rte({ el: $rte[i] }));
    }

    rimg.init();

    if ($('body').hasClass('template-index')) {
      this.templateIndex = new TemplateIndex({ el: this.el });
    }

    if ($('body').hasClass('template-collection')) {
      this.templateCollection = new TemplateCollection({ el: this.el });
    }

    if ($('body').hasClass('template-list-collections')) {
      this.templateListCollections = new TemplateListCollections({ el: this.el });
    }

    if ($('body').hasClass('template-gift-card')) {
      $script(scripts.qrcode, () => {
        this.templateGiftCard = new TemplateGiftCard({ el: this.el });
      });
    }

    if ($('body').hasClass('template-customers-login')) {
      this.templateAccountLogin = new TemplateAccountLogin({ el: this.el });
    }

    if ($('body').hasClass('template-customers-addresses')) {
      this.templateAccountAddresses = new TemplateAccountAddresses({ el: this.el });
    }

    if ($('body').hasClass('template-password')) {
      this.templatePassword = new TemplatePassword({ el: this.el });
    }

    $('.field').on('focus', this.removeErrors.bind(this));

    if (document.querySelector('[data-quickshop]')) {
      this.quickshop = new Quickshop();

      $('[data-quickshop-id]').on('click', (event) => {
        event.preventDefault();
        const productUrl = $(event.currentTarget).data('product-url');
        const productSha256 = $(event.currentTarget).data('product-sha256');
        this.quickshop.open(productUrl, productSha256);
      });
    }
  }

  removeErrors(e) {
    const field = $(e.currentTarget, this.el);
    return field.removeClass('error');
  }
}

$script([
  scripts.countries,
  scripts.currencies,
  scripts.customer_area,
  scripts.jquery_api,
  scripts.plugins,
  scripts.shopify_common,
], () => {
  $script([
    scripts.jquery_cart,
    scripts.jquery_currencies,
  ], () => new Atlantic());
});
